import script from "./UpdateProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&setup=true&lang=js"

import "./UpdateProfile.vue?vue&type=style&index=0&id=5a5f3a3d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5f3a3d"]])

export default __exports__